;(function() {
  'use strict'

  App.$inject = ["$scope", "userService", "statsService"];
  angular.module('app').controller('App', App)

  // --------------------

  /* @ngInject */
  function App($scope, userService, statsService) {
    $scope.app = {}
    $scope.app.user = userService.get()
    $scope.app.stats = statsService.get()

    $scope.showLogin = userService.showLogin
    $scope.showSignup = userService.showSignup
  }
})()
